import classNames from 'classnames';
import { useI18n } from '@/libraries/contexts/i18n-context';
import Typography from '@/components/atoms/typography/typography';
import { useWindowSize } from '@/libraries/hooks/use-window-size';
import styles from './guest-satisfaction.module.scss';

export interface GuestSatisfactionProps {
  /** The class name to apply */
  className?: string;
  /** The number of ratings */
  numberOfReviews: Content.Components['GuestSatisfaction']['numberOfReviews'];
  /** The rating value */
  rating: Content.Components['GuestSatisfaction']['rating'];
  /** The title to display */
  title: Content.Components['GuestSatisfaction']['title'];
}

const MAX_RATING = 5;

const GuestSatisfaction = ({
  className,
  numberOfReviews,
  rating,
  title,
}: GuestSatisfactionProps) => {
  const { t } = useI18n();
  const isTablet = useWindowSize('tablet');

  return isTablet ? (
    <div className={classNames(styles.component, className)}>
      <div className={styles.textWrapper}>
        <Typography className={styles.title} tagStyle="labelSmall">
          {title}
        </Typography>

        <Typography className={styles.numberOfReviews} tagStyle="labelSmall">
          {`${numberOfReviews} ${t('items.common.words.guestRatings')}`}
        </Typography>
      </div>

      <div className={styles.ratingWrapper}>
        <Typography tagStyle="headingMedium">{rating}</Typography>

        <Typography tagStyle="bodyMediumBold">/{MAX_RATING}</Typography>
      </div>
    </div>
  ) : (
    <div className={classNames(styles.component, styles.isCompact, className)}>
      <div className={styles.top}>
        <div className={styles.scoreWrapper}>
          <Typography tagStyle="bodyMediumBold">{rating}</Typography>

          <Typography tagStyle="bodySmallBold">/{MAX_RATING}</Typography>
        </div>

        <Typography className={styles.title} tagStyle="labelSmall">
          {title}
        </Typography>
      </div>

      <Typography className={styles.bottom} tagStyle="labelSmall">
        {`${numberOfReviews} ${t('items.common.words.guestRatings')}`}
      </Typography>
    </div>
  );
};

GuestSatisfaction.displayName = 'GuestSatisfaction';

export default GuestSatisfaction;
